module.exports = __webpack_public_path__ + "static/img/vyvazovaci_ventil_prirubovy.54eab51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vyvazovaci_ventil_prirubovy.png
// module id = bJHC
// module chunks = 1